import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';
import Form from '../../../../components/form/Form';
import React from 'react';
import { AdresseModel } from '../../../../models/AdresseModel';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';
import { setAdresseField } from '../../../../redux/actions/adresserfassung';
import { Adresse } from '../../../../api';
import { nameof } from '../../../../utils/objectUtils';
import { ConfigModel } from '../../../../models/ConfigModel';

interface KontaktProps {
  adresse: AdresseModel;
  setAdresseField: (value: any, fieldName: string) => void;
  showTTMailAdress: boolean;
  config: ConfigModel;
}

const Kontakt = (props: KontaktProps) => {
  return (
    <Form classes='adr-kontakt-form'>
      <div id='adr-kontakt-telefon'>
        <InputFieldText
          label='Kontakt'
          name={nameof<Adresse>('kontakt')}
          maxlength={100}
          classes='adr-kontakt'
          value={props.adresse.kontakt}
          onChangeHandler={value =>
            props.setAdresseField(value, nameof<Adresse>('kontakt'))
          }
          readonly={
            !!props.adresse.inUebertragung && !props.config.isAdresseKontaktEdit
          }
        />
        <InputFieldText
          label='Telefon'
          name={nameof<Adresse>('telefon')}
          maxlength={50}
          classes='adr-telefon'
          inputType='tel'
          value={props.adresse.telefon}
          onChangeHandler={value =>
            props.setAdresseField(value, nameof<Adresse>('telefon'))
          }
          readonly={
            !!props.adresse.inUebertragung && !props.config.isAdresseTelefonEdit
          }
        />
        {props.showTTMailAdress && (
          <InputFieldText
            label='E-Mailadresse Track & Trace'
            name={nameof<Adresse>('mailTrackTrace')}
            maxlength={250}
            classes='adr-tt_mail'
            value={props.adresse.mailTrackTrace}
            onChangeHandler={value =>
              props.setAdresseField(value, nameof<Adresse>('mailTrackTrace'))
            }
          />
        )}
      </div>
    </Form>
  );
};

const mapStateToProps = (state: StateModel) => ({
  adresse: state.Adresserfassung,
  config: state.Config,
  showTTMailAdress: state.Config.isShowTTMailAdress,
});

export default connect(mapStateToProps, { setAdresseField })(Kontakt);
